import { VarioTypeMapping } from 'pkg-trinity-client'

export interface Mutation<T = any> {
  type: string
  payload: T
}
// Generated by https://quicktype.io
//
// To change quicktype's target language, run command:
//
//   "Set quicktype target language"

export interface State {
  campaigns: Campaigns
  content: CheckoutMultiCabinContent
  ships: Ships
  searching: Searching
  booking: CheckoutMultiCabinBooking
  tracking: Tracking
  appContext: Context
  realperson: Realperson
  planning: any
  route: Route
}

export interface Route {
  name: string
  path: string
  hash: string
  query: TrapaniSnowLeopard
  params: RouteParams
  fullPath: string
  meta: TrapaniSnowLeopard
  from?: Route
}

export interface Context {
  embedded: null
  source: null
  url: any
  language: string
}

export interface CheckoutMultiCabinBooking {
  activeCabinKey: string
  basket: string[]
  storeCurrency: StoreCurrency
  currencyList: CurrencyList
  currencyConversion: boolean
  loading: null
  resetFlex: boolean
  checkout: Checkout
  general: General
  cabin1: Cabin1Class
  cabin2: Cabin1Class
  cabin3: Cabin3Class
  cabin4: Cabin3Class
  context: Context
  affiliate: Affiliate
}

export interface Affiliate {
  agencyId: null
  lastAffiliateContact: null
}

export interface Cabin1Class {
  cabins: CabinsClass
  insurance: Insurance
  pax: Cabin1Pax
  persons: Persons
  transport: Transport
  transportAir: Cabin1TransportAir
  transportRail: TransportRail
  wizard: Wizard
  checkinTime: Cabin1CheckinTime
  ibeLink: IbeLink
  loadTransportation: LoadTransportation
  stations: Stations
  transportAvailability: TransportAvailability
}

export type ActiveAdditionalCategoryState = 'NONE' | 'PREMIUM' | 'PREMIUMAI'

export interface CabinsClass {
  cabinCategories: Category[]
  priceModelSupportsPremium: boolean
  cabinCategory: null | string
  activeAdditionalCategory: ActiveAdditionalCategoryState
  selectionCategoryConfigurations: SelectionCategoryConfiguration[]
  mainCabinCategories: MainCabinCategory[]
  loadingCabinCategories: string
  loadingCabins: string
  loadingWishCabin: string
  loadingRequiredCabin: LoadingRequiredCabin
  cabins: any[]
  decks: Deck[]
  selectedByOtherStores: any[]
  priceDiffers: any[]
  cabinAutoReset: boolean
  fetchCategoriesDone: boolean
}

export interface Category {
  code: string
  description: Description
  displayDescription: string[]
  amenities: any[]
  available: boolean
  img: string
  maxOcc: number
  minOcc: number
  price: number
  name: DisplayNameEnum
  displayName: DisplayNameEnum
  surcharges: Surcharge[]
  pricingsPerPax: number[]
  shipCode: ShipCode
  surchargeEB: number
  surchargeEBP: number
  premiumCategories?: Category[]
  premiumAvailable?: boolean
  premiumAIAvailable?: boolean
  cheapestPremiumPrice?: number
  cheapestPremiumAIPrice?: number
  mainCode: MainCode
  head?: string
}

export interface Description {
  lines: Line[]
}

export enum Line {
  Ab14M = 'ab 14 m²',
  BadMITDusche = 'Bad mit Dusche',
  FürBisZu3Personen = 'Für bis zu 3 Personen',
  FürBisZu4Personen = 'Für bis zu 4 Personen',
  FürBisZu5Personen = 'für bis zu 5 Personen',
  KabineMITBalkonAb3M = 'Kabine mit Balkon (ab 3 m²)',
  KabineMITBalkonCA45M = 'Kabine mit Balkon (ca. 4,5 m²)',
  MITDoppelbett = 'mit Doppelbett',
  MITDoppelbettUndZusatzbett = 'mit Doppelbett und Zusatzbett',
  NurWenigeSchritteVomWellnessUndFitnessbereichEntfernt = 'nur wenige Schritte vom Wellness- undFitnessbereich entfernt',
  SuiteMITPrivatemBalkonOderSonnendeck1082M = 'Suite mit privatem Balkon oder Sonnendeck (10-82 m²)',
  TeilweiseGetrenntStehendeBetten = 'teilweise getrennt stehende Betten',
  TeilweiseMITVerbindungstür = 'teilweise mit Verbindungstür',
  TeilweiseMITVerbindungstürTeilweiseBarrierefrei = 'teilweise mit Verbindungstür, teilweise barrierefrei',
  The13145M = '13 - 14,5 m²',
  The13519M = '13,5 - 19 m²',
  The215M = '21,5 m²',
}

export enum DisplayNameEnum {
  Balkonkabine = 'Balkonkabine',
  Innenkabine = 'Innenkabine',
  Meerblickkabine = 'Meerblickkabine',
  PanoramaBalkonkabine = 'Panorama-Balkonkabine',
  Suite = 'Suite',
}

export enum MainCode {
  B = 'B',
  I = 'I',
  M = 'M',
  P = 'P',
  S = 'S',
}

export enum ShipCode {
  So = 'SO',
}

export interface Surcharge {
  amount: number
  type: SurchargeType
}

export enum SurchargeType {
  Bgh = 'BGH',
  Eb = 'EB',
  Ebp = 'EBP',
}

export interface Deck {
  uid: string
  deck: number
  deckImage: DetachedImage
}

export interface DetachedImage {
  alt?: null
  uid: null
  file: null | string
  keywords?: null
}

export interface LoadingRequiredCabin {
  cabinNumber: null
  lastFoundCabinNumberForScrollingIntoView: null
  message: Message
}

export interface Message {
  header: string
  level: string
  message: string
  reference: string
  type: string
}

export interface MainCabinCategory {
  image: string
  cabinCategories: MainCabinCategoryCabinCategory[]
  name: string
  description: Description
  descriptionMarkdown: null
  descriptionHtml: null
  id: string
}

export interface MainCabinCategoryCabinCategory {
  name: PurpleName
  head: string
  description: null
  descriptionHtml: null
  id: string
}

export enum PurpleName {
  Balkonkabine = 'Balkonkabine',
  Innenkabine = 'Innenkabine',
  Meerblickkabine = 'Meerblickkabine',
  Suite = 'Suite',
}

export interface SelectionCategoryConfiguration {
  deck: null
  cabin: null
  shipSection: null
  subCategory: null
  currentStep: CurrentStep
  lowCabinInfo: boolean
  mainCategory: string
}

export enum CurrentStep {
  PS = 'PS',
}

export interface Cabin1CheckinTime {
  loading: boolean
  checkinTime: PurpleCheckinTime
}

export interface PurpleCheckinTime {
  data: CheckinTime
  Start: string
  End: string
}

export interface CheckinTime {
  Start: null
  End: null
}

export interface IbeLink {
  link: null
}

export interface Insurance {
  loading: string
  list: InsuranceList[]
  selected: string
  priceDiffer: any[]
}

export interface InsuranceList {
  code: string
  price: number
}

export interface LoadTransportation {
  loading: boolean
}

export interface Cabin1Pax {
  paxe: Paxe[]
  allFieldsValid: boolean
  erpFieldsValid: boolean
  formValidations: { [key: string]: Validation[] }
  departureDate: string
  transportationType: string
}

export interface Validation {
  field: string
  rules: Rule[]
}

export interface Rule {
  regex: string
  triggerIfMatch: boolean
  message: string
  type: RuleType
}

export enum RuleType {
  Error = 'error',
}

export interface Paxe {
  isBuyer: boolean
  sex: Address
  firstName: Address
  lastName: Address
  birthday: Address
  nationalityCode: Address
  erpConfirm: Address
  erpInfo: ERPInfo
  erpInfos: ERPInfo[]
}

export interface Address {
  touched: boolean
  value: string
  valid: boolean
  error: null
  errorShort?: null
  warning: null
  name: string
  type: PurpleType
  placeholder: string
}

export enum PurpleType {
  Checkbox = 'checkbox',
  Email = 'email',
  Select = 'select',
  Text = 'text',
}

export interface ERPInfo {
  erpId: null | string
  erpLink: null | string
  erpText: null | string
}

export interface Persons {
  adults: number
  juveniles: number
  children: number
  locked: boolean
}

export interface Stations {
  loading: boolean
  stations: any[]
}

export interface Transport {
  type: null | string
  subType: null
  noneOptions: NoneOptions
  transportation: any[]
}

export interface NoneOptions {
  none: boolean
}

export interface Cabin1TransportAir {
  priceDiffer: number
  priceDifference: number
  selectedConnection: null
  mandatoryRoundtrip: boolean
  loading: string
  roundtripsOnly: boolean
  withNoFlight: boolean
  withOutNoFlight: boolean
  withRetNoFlight: boolean
  flightsOutTouched: boolean
  flightsRetTouched: boolean
  outgoingSelection: IngSelection
  returningSelection: IngSelection
  flights: PurpleFlights
}

export interface PurpleFlights {
  twoWay: TwoWay
  outgoing: Outgoing
  returning: Returning
  flightClasses: SelectedCruise[]
}

export interface SelectedCruise {
  code: string
  name: string
}

export interface Outgoing {
  Y: OutgoingY
}

export interface OutgoingY {
  VIE: Cgn[]
  LEJ: Lej[]
  DUS: Cgn[]
  FRA: Fra[]
  NUE: Cgn[]
  FMO: Cgn[]
  HAM: Cgn[]
  HAJ: Cgn[]
  CGN: Cgn[]
  TXL: Cgn[]
  MUC: Cgn[]
  STR: Cgn[]
}

export interface Cgn {
  code: string
  class: Class
  className: ClassName
  outgoingFlight: OutgoingFlight | null
  outgoingFlightCode: PurpleOutgoingFlightCode
  returnFlight: PurpleReturnFlight | null
  returnFlightCode: string
  flightDirection: FlightDirectionEnum
}

export enum Class {
  Y = 'Y',
}

export enum ClassName {
  Economy = 'Economy',
}

export enum FlightDirectionEnum {
  O = 'O',
  Oj = 'OJ',
  R = 'R',
  Rt = 'RT',
}

export interface OutgoingFlight {
  segments: PurpleSegment[]
  price: number
}

export interface PurpleSegment {
  arrivalAirportCode: PurpleAirportCode
  arrivalAirportName: PurpleAirportName
  arrivalDate: ArrivalDateEnum
  arrivalTime: string
  carrier: PurpleCarrier
  class: Class
  className: ClassName
  departureAirportCode: PurpleAirportCode
  departureAirportName: PurpleAirportName
  departureDate: ArrivalDateEnum
  departureTime: string
}

export enum PurpleAirportCode {
  Cgn = 'CGN',
  Dus = 'DUS',
  FMO = 'FMO',
  Haj = 'HAJ',
  Ham = 'HAM',
  Lej = 'LEJ',
  Muc = 'MUC',
  Nue = 'NUE',
  Pmi = 'PMI',
  Str = 'STR',
  Txl = 'TXL',
  Vie = 'VIE',
}

export enum PurpleAirportName {
  BerlinTegel = 'Berlin/Tegel',
  Düsseldorf = 'Düsseldorf',
  Hamburg = 'Hamburg',
  Hannover = 'Hannover',
  KölnBonn = 'Köln/Bonn',
  LeipzigHalle = 'Leipzig-Halle',
  München = 'München',
  MünsterOsnabrück = 'Münster/Osnabrück',
  Nürnberg = 'Nürnberg',
  PalmaDeMallorca = 'Palma de Mallorca',
  Stuttgart = 'Stuttgart',
  Wien = 'Wien',
}

export enum ArrivalDateEnum {
  The12012019 = '12.01.2019',
  The19012019 = '19.01.2019',
}

export interface PurpleCarrier {
  code?: Code
  name?: FluffyName
  number?: string
  logo?: PurpleLogo
}

export enum Code {
  Ew = 'EW',
  X3 = 'X3',
}

export interface PurpleLogo {
  uid: null
  file: string
}

export enum FluffyName {
  Eurowings = 'Eurowings',
  TUIfly = 'TUIfly',
}

export enum PurpleOutgoingFlightCode {
  Cgn = 'CGN',
  Dus = 'DUS',
  Empty = '',
  FMO = 'FMO',
  Haj = 'HAJ',
  Ham = 'HAM',
  Lej = 'LEJ',
  Muc = 'MUC',
  Nue = 'NUE',
  Str = 'STR',
  Txl = 'TXL',
  Vie = 'VIE',
}

export interface PurpleReturnFlight {
  segments: FluffySegment[]
  price: number | number
}

export interface FluffySegment {
  arrivalAirportCode: ArrivalAirportCodeEnum
  arrivalAirportName: ArrivalAirportNameEnum
  arrivalDate: ArrivalDateEnum
  arrivalTime: string
  carrier: FluffyCarrier
  class: Class
  className: ClassName
  departureAirportCode: PurpleAirportCode
  departureAirportName: PurpleAirportName
  departureDate: ArrivalDateEnum
  departureTime: string
}

export enum ArrivalAirportCodeEnum {
  Cgn = 'CGN',
  Dus = 'DUS',
  FMO = 'FMO',
  Fra = 'FRA',
  Haj = 'HAJ',
  Ham = 'HAM',
  Lej = 'LEJ',
  Muc = 'MUC',
  Nue = 'NUE',
  Pmi = 'PMI',
  Str = 'STR',
  Txl = 'TXL',
  Vie = 'VIE',
}

export enum ArrivalAirportNameEnum {
  BerlinTegel = 'Berlin/Tegel',
  Düsseldorf = 'Düsseldorf',
  Frankfurt = 'Frankfurt',
  Hamburg = 'Hamburg',
  Hannover = 'Hannover',
  KölnBonn = 'Köln/Bonn',
  LeipzigHalle = 'Leipzig-Halle',
  München = 'München',
  MünsterOsnabrück = 'Münster/Osnabrück',
  Nürnberg = 'Nürnberg',
  PalmaDeMallorca = 'Palma de Mallorca',
  Stuttgart = 'Stuttgart',
  Wien = 'Wien',
}

export interface FluffyCarrier {
  code?: CodeEnum
  name?: AirlineName
  number?: string
  logo?: DetachedImage
}

export enum CodeEnum {
  Ew = 'EW',
  X3 = 'X3',
  Xg = 'XG',
}

export enum AirlineName {
  Eurowings = 'Eurowings',
  SunexpressDeutschland = 'Sunexpress Deutschland',
  TUIfly = 'TUIfly',
}

export interface Fra {
  code: string
  class: Class
  className: ClassName
  outgoingFlight: OutgoingFlightClass | null
  outgoingFlightCode: string
  returnFlight: OutgoingFlightClass | null
  returnFlightCode: string
  flightDirection: FlightDirectionEnum
}

export interface OutgoingFlightClass {
  segments: TentacledSegment[]
  price: number
}

export interface TentacledSegment {
  arrivalAirportCode: string
  arrivalAirportName: string
  arrivalDate: ArrivalDateEnum
  arrivalTime: string
  carrier: TentacledCarrier
  class: Class
  className: ClassName
  departureAirportCode: string
  departureAirportName: string
  departureDate: ArrivalDateEnum
  departureTime: string
}

export interface TentacledCarrier {
  code?: CodeEnum
  name?: AirlineName
  number?: string
  logo?: FluffyLogo
}

export interface FluffyLogo {
  uid: null
  file: string
  alt?: null
}

export interface Lej {
  code: string
  class: Class
  className: ClassName
  outgoingFlight: OutgoingFlight | null
  outgoingFlightCode: LEJOutgoingFlightCode
  returnFlight: LEJReturnFlight | null
  returnFlightCode: string
  flightDirection: string
}

export enum LEJOutgoingFlightCode {
  Empty = '',
  Lej = 'LEJ',
  Vie = 'VIE',
}

export interface LEJReturnFlight {
  segments: StickySegment[]
  price: number
}

export interface StickySegment {
  arrivalAirportCode: FluffyAirportCode
  arrivalAirportName: FluffyAirportName
  arrivalDate: ArrivalDateEnum
  arrivalTime: string
  carrier: FluffyCarrier
  class: Class
  className: ClassName
  departureAirportCode: FluffyAirportCode
  departureAirportName: FluffyAirportName
  departureDate: ArrivalDateEnum
  departureTime: string
}

export enum FluffyAirportCode {
  Cgn = 'CGN',
  Dus = 'DUS',
  FMO = 'FMO',
  Fra = 'FRA',
  Haj = 'HAJ',
  Ham = 'HAM',
  Muc = 'MUC',
  Nue = 'NUE',
  Pmi = 'PMI',
  Str = 'STR',
  Txl = 'TXL',
  Vie = 'VIE',
}

export enum FluffyAirportName {
  BerlinTegel = 'Berlin/Tegel',
  Düsseldorf = 'Düsseldorf',
  Frankfurt = 'Frankfurt',
  Hamburg = 'Hamburg',
  Hannover = 'Hannover',
  KölnBonn = 'Köln/Bonn',
  München = 'München',
  MünsterOsnabrück = 'Münster/Osnabrück',
  Nürnberg = 'Nürnberg',
  PalmaDeMallorca = 'Palma de Mallorca',
  Stuttgart = 'Stuttgart',
  Wien = 'Wien',
}

export interface Returning {
  Y: ReturningY
}

export interface ReturningY {
  VIE: Cgn[]
  FMO: Fra[]
  MUC: Cgn[]
  TXL: Cgn[]
  LEJ: Cgn[]
  FRA: Lej[]
  DUS: Fra[]
  NUE: Cgn[]
  STR: Cgn[]
  CGN: Lej[]
  HAJ: Cgn[]
  HAM: Cgn[]
}

export interface TwoWay {
  Y: TwoWayY
}

export interface TwoWayY {
  NUE: Cgn[]
  HAM: Fra[]
  STR: Cgn[]
  LEJ: Cgn[]
  FMO: Cgn[]
  HAJ: Cgn[]
  DUS: Cgn[]
  MUC: Cgn[]
  TXL: Cgn[]
  CGN: Cgn[]
  FRA: Fra[]
  VIE: Lej[]
}

export interface IngSelection {
  activated: boolean
  selected: string
  flightClass: null | string
  enabled: boolean
}

export interface TransportAvailability {
  flight: boolean
  rail: boolean
  none: boolean
}

export interface TransportRail {
  departure: boolean
  departureConfig: Config
  departureSelectionList: SelectionList
  arrival: boolean
  arrivalConfig: Config
  arrivalSelectionList: SelectionList
  transportations: any[]
  paxWithDiscount: boolean[]
  stations: any[]
  checkinTime: CheckinTime
  totalPrice: number
}

export interface Config {
  location: null
  locationCode: null
  category: string
  date?: string
}

export interface SelectionList {
  selection: null
  open: boolean
  current: number
  stations: any[]
  stationNames: any[]
}

export interface Wizard {
  steps: StepElement[]
  stepInfo: Step[]
}

export interface Step {
  name: StepInfoName
  validGetter: string
}

export enum StepInfoName {
  BookingCabinCategory = 'bookingCabinCategory',
  BookingInsurance = 'bookingInsurance',
  BookingPax = 'bookingPax',
  BookingPersons = 'bookingPersons',
  BookingTransport = 'bookingTransport',
}

export interface StepElement {
  required: boolean
  completed: boolean
  name: string
  stepConfig: Step
}

export interface Cabin3Class {
  cabins: CabinsClass
  insurance: Insurance
  pax: Cabin3Pax
  persons: Persons
  transport: Transport
  transportAir: Cabin3TransportAir
  transportRail: TransportRail
  wizard: Wizard
  checkinTime: Cabin3CheckinTime
  ibeLink: IbeLink
  loadTransportation: LoadTransportation
  stations: Stations
  transportAvailability: TransportAvailability
}

export interface Cabin3CheckinTime {
  loading: boolean
  checkinTime: FluffyCheckinTime
}

export interface FluffyCheckinTime {
  data: CheckinTime
}

export interface Cabin3Pax {
  paxe: Paxe[]
  allFieldsValid: boolean
  erpFieldsValid: boolean
  formValidations: TrapaniSnowLeopard
  departureDate: string
  transportationType: string
}

export interface TrapaniSnowLeopard {}

export interface Cabin3TransportAir {
  priceDiffer: number
  priceDifference: number
  selectedConnection: null
  mandatoryRoundtrip: boolean
  loading: string
  roundtripsOnly: boolean
  withNoFlight: boolean
  withOutNoFlight: boolean
  withRetNoFlight: boolean
  flightsOutTouched: boolean
  flightsRetTouched: boolean
  outgoingSelection: IngSelection
  returningSelection: IngSelection
  flights: FluffyFlights
}

export interface FluffyFlights {
  twoWay: TrapaniSnowLeopard
  outgoing: TrapaniSnowLeopard
  returning: TrapaniSnowLeopard
  flightClasses: any[]
}

export interface Checkout {
  primaryPaxId: number
  price: PriceClass
  email: Address
  phone: Address
  address: Address
  zipCode: Address
  city: Address
  countryCode: Address
  ippField: IPPField
  allFieldsValid: boolean
  formValidations: { [key: string]: Validation[] }
  paymentCountries: PaymentCountry[]
  tradingConditionsAccepted: boolean
  tradingConditionsAcceptedHasError: boolean
  formSheetPauschal: boolean
  formSheetPauschalHasError: boolean
  insuranceBooked: boolean
  insuranceConditionsAccepted: boolean
  insuranceConditionsAcceptedHasError: boolean
  ippBooked: boolean
  formPDF: string
}

export interface IPPField {
  error: boolean
  touched: boolean
  valid: boolean
  value: null
}

export interface PaymentCountry {
  isoCode: string
  zipFormat: string
  zipPrefix?: string
  name: string
}

export interface PriceClass {
  fullPrice: number
  deposit: number
  outstanding: number
  deadline: string
}

export interface CurrencyList {
  currencies: Currencies
}

export interface Currencies {
  DE: string
  CH: string
}

export interface General {
  booking: GeneralBooking
  cruise: GeneralCruise
  countries: { [key: string]: CountryValue }
  paymentCountries: PaymentCountry[]
  validations: { [key: string]: Validation[] }
  sexes: Sexes
  ships: ShipElement[]
}

export interface GeneralBooking {
  loading: boolean
  number: string
  verToken: string
  error: null
  confirmation: string
}

export interface CountryValue {
  isoCode: string
  name: string
  phone: string
}

export interface GeneralCruise {
  amenityPrice: number
  departure: string
  priceModel: string
  id: string
  arrival: string
  arrivalGermany: boolean
  arrivalStationName: string
  cruiseId: string
  departureGermany: boolean
  departureStationName: string
  shipCode: string
  routeCode: string
  shipName: string
  mandatoryFlight: { [key: string]: boolean }
  region: string
  ports: CruisePort[]
  duration: number
  name: string
  description: string
  shipImage: string
  shipDetachedImage: string
  routeMap: string
  seasonCd: string
  shortTerm: boolean
  routeName: string
}

export interface CruisePort {
  name: string
  arrivalTime?: string
  departureTime?: string
  code: string
  coordinates?: Coordinates
  countryCode: string
  date: string
  portOfArrival?: boolean
  portOfDeparture?: boolean
  unloCode: string
}

export interface Coordinates {
  latitude: number
  longitude: number
}

export interface Sexes {
  M: string
  F: string
}

export interface ShipElement {
  food: PurpleCabins
  commissioning: string
  status: string
  createdAt: string
  videoLink: null
  entertainment: PurpleCabins
  decks: Deck[]
  name: string
  mainCabinCategories: MainCabinCategory[]
  marketingText: string
  enviroment: PurpleCabins
  wellness: PurpleCabins
  cabins: PurpleCabins
  detachedImage: DetachedImage
  shipSectionImages: ShipSectionImages
  christening: PurpleCabins
  files: Files
  updatedAt: string
  technicalData: TechnicalData
  family: PurpleCabins
  articles: Article[]
  cabinCategories: ShipCabinCategory[]
  id: string
  teaserImage: DetachedImage
}

export interface Article {
  teaserText: null
  uid: string
  contentSections: any[]
  subHeadline: null | string
  description: null
  descriptionHtml: null
  videoLink: null
  category: string
  headline: null | string
  teaserImage: DetachedImage
  gallery: any[]
}

export interface ShipCabinCategory {
  name: PurpleName
  head: string
  main: Main
  id: string
}

export enum Main {
  B = 'B',
  I = 'I',
  M = 'M',
  S = 'S',
}

export interface PurpleCabins {
  teaserText: null
  contentSections: any[]
  subHeadline: null | string
  description: null
  descriptionHtml: null
  videoLink: null
  headline: null | string
  teaserImage: DetachedImage
}

export interface Files {
  prospect: Deckplan
  deckplan: Deckplan
}

export interface Deckplan {
  uid: null
  file: null
  text: null
}

export interface ShipSectionImages {
  centerGrey: DetachedImage
  backBlue: DetachedImage
  backGrey: DetachedImage
  centerBlue: DetachedImage
  frontBlue: DetachedImage
  frontGrey: DetachedImage
}

export interface TechnicalData {
  grossTonnage: null
  decksCount: null
  engine: null
  draft: null
  length: null
  width: null
  electricPower: null
}

export interface StoreCurrency {
  currency: string
  convert: boolean
  conversion: number
}

export interface Campaigns {
  exchangeRates: CampaignsExchangeRates
  lastMinuteOffers: LastMinuteOffersClass
  varioOffers: VarioOffers
  pauschalOffers: LastMinuteOffersClass
  vdwOffers: VdwOffersClass
  weeOffers: VdwOffersClass
  pauschalTeaserOffers: PauschalTeaserOffers
  persons: Persons
}

export interface CampaignsExchangeRates {
  convert: boolean
  exchangeRates: ExchangeRatesExchangeRates
  location: string
}

export interface ExchangeRatesExchangeRates {
  EUR: TrapaniSnowLeopard
}

export interface LastMinuteOffersClass {
  config: LastMinuteOffersConfig
  carolCampaign: { [key: string]: any[] | null }
  filter: LastMinuteOffersFilter
  sortBy: SortBy
  specialSortBy: SortBy
  searchResults: any[]
  specialResults: TrapaniSnowLeopard
  availableDurations: AvailableDuration[]
  numberCruises: number
}

export interface AvailableDuration {
  id: number
  name: string
  shortName?: string
  from: number
  to: number
}

export interface LastMinuteOffersConfig {
  campaignId: string
  persons: string
  priceModel: null | string
  weeks: number | null
}

export interface LastMinuteOffersFilter {
  depGermany: boolean
  flightIncluded: boolean
  priceModel: null | string
  travelDuration: number
}

export interface SortBy {
  code: string
  name: string
  shortName: string
}

export interface PauschalTeaserOffers {
  params: PauschalTeaserOffersParams
  backgroundImages: any[]
  flights: TrapaniSnowLeopard
  searchResults: any[]
  paramsTouched: boolean
  searchButtonTouched: boolean
  availableRegions: any[]
  availableShips: any[]
  availableAirports: any[]
  availableDurations: AvailableDuration[]
  availableExtraFilters: SelectedCountry[]
}

export interface SelectedCountry {
  id: string
  name: string
}

export interface PauschalTeaserOffersParams {
  adults: number
  juveniles: number
  children: number
  ship: null
  regionID: null
  timeFrom: null
  timeTo: null
  departureAirport: null | string
  travelDuration: null
  extraFilter: null | string
  shipID?: string
}

export interface VarioOffers {
  config: VarioOffersConfig
  carolCampaign: { [key: string]: any[] | null }
  aprilCampaigns: TrapaniSnowLeopard
  filter: VarioOffersFilter
  sortBy: SortBy
  specialSortBy: SortBy
  searchResults: any[]
  specialResults: TrapaniSnowLeopard
  availableDurations: AvailableDuration[]
  availableAirports: any[]
  availableRegions: any[]
  availableShips: any[]
  numberCruises: number
  paging: Paging
}

export interface VarioOffersConfig {
  campaignId: string
  persons: string
  priceModel: string
  priceGroups: number[]
  numberPages: number
}

export interface VarioOffersFilter {
  depGermany: boolean
  flightIncluded: boolean
  priceModel: string
  airport: null
  region: null
  shipCode: null
  travelDuration: number
  timeFrom: null
  timeTo: null
  cruises: any[]
}

export interface Paging {
  itemsPerPage: number
  currentPage: number
}

export interface VdwOffersClass {
  config: VdwOffersConfig
  teaserCruises: any[]
  teaserOffers: { [key: string]: null }[]
  carolCampaign: { [key: string]: any[] | null }
}

export interface VdwOffersConfig {
  campaignId: string
  campaignName: string
  persons: string
}

export interface CheckoutMultiCabinContent {
  content: ContentContent
  personae: PersonaeClass
  hub: Hub
  profile: Profile
  persons: Persons
  campaign: PersonaeClass
}

export interface PersonaeClass {
  list: any[]
}

export interface ContentContent {
  list: any[]
  positionedList: any[]
}

export interface Hub {
  selectedDuration: null
  selectedDepartureDate: null
  recommendedCruises: null
}

export interface Profile {
  views: TrapaniSnowLeopard
  likes: TrapaniSnowLeopard
  shares: TrapaniSnowLeopard
  personae: TrapaniSnowLeopard
  travelPersons: TrapaniSnowLeopard
  profileId: null
  config: TrapaniSnowLeopard
  tempConfig: TrapaniSnowLeopard
}

export interface Realperson {
  available: boolean
  loaded: boolean
  tracked: boolean
  activated: boolean
}

export interface RouteParams {
  cruiseId: string
  priceModel: string
}

export interface Searching {
  cruises: SearchingCruises
  entryRegulation: EntryRegulation
  excursions: Excursions
  exchangeRates: CampaignsExchangeRates
  ports: Ports
  search: Search
  chat: Realperson
  persons: Persons
}

export interface SearchingCruises {
  flights: FlightElement[]
  otherFlights: FlightElement[]
  list: CruisesList[]
  countries: CountryElement[]
  current: Current
  excursions: Excursion[]
  priceModel: string
  selectedCabinCategory: SelectedCabinCategory
  selectedCountry: SelectedCountry
  selectedFlight: OtherSelectedFlightClass
  selectedOtherFlight: OtherSelectedFlightClass
  selectedCruise: SelectedCruise
  otherSelectedFlight: OtherSelectedFlightClass
}

export interface CountryElement {
  currencyDescription: null | string
  nationality: boolean
  internationalAreaCode: null | string
  languageDescription: null | string
  updatedAt: string
  createdAt: string
  id: string
  name: string
}

export interface Current {
  duration: number
  endDate: string
  id: string
  mandatoryFlight: MandatoryFlight
  startDate: string
  cabinCategories: SelectedCabinCategory[]
  checkInTimes: CheckInTimes
  itinerary: Itinerary[]
  ports: CurrentPort[]
  journeys: Journey[]
  region: Region[]
  ships: ShipElement[]
  season: string
  campaigns: CampaignElement[]
  cheapestFlights: CheapestFlights
  cheapestCabinCategories: CheapestCabinCategories
  cheapestPrices: CheapestPrices
  germanDeparture: boolean
  germanArrival: boolean
}

export interface SelectedCabinCategory {
  available: boolean
  id: string
  mainID: string
  priceModel: SelectedCabinCategoryPriceModel
  price: number
  pricings: number[]
  occupancy: Occupancy
  amenities: any[]
  surcharges: Surcharge[]
  mainName: string
  mainDescription: Description
  image: string
  promotedInCampaigns: any[]
  name?: string
  head?: string
}

export interface Occupancy {
  min: number
  max: number
}

export enum SelectedCabinCategoryPriceModel {
  Premium = 'PREMIUM',
  Vario = 'VARIO',
}

export interface CampaignElement {
  id: number
  focus: string
  name: string
}

export interface CheapestCabinCategories {
  VARIO: SelectedCabinCategory
}

export interface CheapestFlights {
  VARIO: Premium
  PREMIUM: Premium
}

export interface Premium {
  price: number
  flight: PREMIUMFlight
}

export interface PREMIUMFlight {
  returnArrLoc: string
  outDepLoc: string
  direction: string
}

export interface CheapestPrices {
  VARIO: number
}

export interface CheckInTimes {
  start: string
  end: string
}

export interface Itinerary {
  id: string
  mapImageUrl: string
  name: string
  description: string
}

export interface Journey {
  cruiseID: string
  shipID: string
  regionID: string
  itineraryID: string
  seasonID: string
  arrival: string
  departure: string
  segments: JourneySegment[]
}

export interface JourneySegment {
  arrivalDate: string
  arrivalTime: string
  departureDate: string
  departureTime: string
  portID: string
}

export interface MandatoryFlight {
  VARIO: boolean
  PREMIUM: boolean
}

export interface CurrentPort {
  id: string
  countryID: string
  teaserShort: string
  teaserEmotional: string
  text: string
  aidaTipp: null | string
  sizeDescription: string
  climateDescription: string
  politicsDescription: string
  coordinates: Coordinates
  cityName: string
  teaserListHeader: string
  teaserListText: string
  teaserImage: DetachedImage
  timeZone: string
  name: string
  slug: string
  airportDescription: null | string
  distanceToAirportDescription: null | string
  weatherStation: string
}

export interface Region {
  listHeadline: string
  listText: string
  updatedAt: string
  createdAt: string
  videoLink: string
  id: string
  name: string
  teaserImage: DetachedImage
  marketingTeaser: string
}

export interface Excursion {
  maxAgeInvolved: number
  serviceIntervalDisplayMode: string
  notAllowedForB2B: boolean
  thumbnailMediaUrl: string
  roomType: null
  maxAge: number
  iCode: string
  durationTotal: number
  longDescription: null
  thumbnailMediaCode: string
  assignmentPeriod: string
  subscriptionPossible: boolean
  mainCategoryCodes: string[]
  businessRuleCodes: any[]
  shipID: string
  itemType: string
  id: string
  introduction: null
  duration: number
  maxQuantityPerPaxAndCruise: number
  icode: string
  remarksForPreBooking: RemarksForPreBooking
  infantIncluded: boolean
  shipCode: null
  additionalCustomerAttributes: any[]
  productType: string
  lastUpdated: string
  thumbnailMediaQuery: string
  categoryCodes: string[]
  extendedRemarks: ExtendedRemark[]
  media: Media[]
  portCode: string
  sortIndex: number
  cruisePlannerDisplayMode: string
  subtitle: string
  additionalItemAttributes: AdditionalItemAttribute[]
  minAge: number
  maxAgeChildPrice: number
  mealsAndBeverages: string
  minAgeChildPrice: number
  mediaQuery: string
  maxQuantityPerPax: number
  description: string
  remarks: string[]
  minParticipants: number
  minAgeInvolved: number
  maxParticipants: number
  title: string
}

export interface AdditionalItemAttribute {
  itemAttrCode: string
  itemAttrMaxLength: number
  itemAttrValues: string[]
  itemAttrCheckRegex: null
  itemAttrMinLength: number
  itemAttrValueType: string
  itemAttrMaxValue: number
  itemAttrMinValue: number
}

export interface ExtendedRemark {
  code: string
  typeCode: TypeCode
  important?: boolean
}

export enum TypeCode {
  Hint = 'hint',
  TicketInfo = 'ticketInfo',
}

export interface Media {
  mediaUrl: string
  mediaCode: string
}

export interface RemarksForPreBooking {
  ticketInfoRemarks: string[]
  otherRemarks: string[]
}

export interface FlightElement {
  class: Class
  className: ClassName
  connections: Connection[]
  direction: FlightDirectionEnum
  id: string
  price: number
}

export interface Connection {
  arrival: Arrival
  airline?: Airline
  class: Class
  className: ClassName
  departure: Arrival
  direction: ConnectionDirection
  flightNumber?: string
}

export interface Airline {
  id: CodeEnum
  name: AirlineName
  alias: Alias
  icao: Icao
  callsign: Callsign
  country: CountryEnum
  active: boolean
  logo: DetachedImage
}

export enum Alias {
  N = '\\N',
}

export enum Callsign {
  Calima = 'CALIMA',
  Eurowings = 'EUROWINGS',
  YellowCab = 'YELLOW CAB',
}

export enum CountryEnum {
  Germany = 'Germany',
  Spain = 'Spain',
}

export enum Icao {
  CLI = 'CLI',
  Ewg = 'EWG',
  Hlx = 'HLX',
}

export interface Arrival {
  airport: AirportClass
  time: string
}

export interface AirportClass {
  id: ArrivalAirportCodeEnum
  name: ArrivalAirportNameEnum
  ident: GpsCode
  type: AirportType
  coordinates: Coordinates
  elevationFeet: number
  continent: Continent
  isoCountry: ISOCountry
  isoRegion: ISORegion
  municipality: Municipality
  scheduledService: ScheduledService
  gpsCode: GpsCode
  localCode: null
  homeLink: null | string
  wikipediaLink: string
  keywords: Keyword[]
}

export enum Continent {
  Eu = 'EU',
}

export enum GpsCode {
  Eddf = 'EDDF',
  Eddg = 'EDDG',
  Eddh = 'EDDH',
  Eddk = 'EDDK',
  Eddl = 'EDDL',
  Eddm = 'EDDM',
  Eddn = 'EDDN',
  Eddp = 'EDDP',
  Edds = 'EDDS',
  Eddt = 'EDDT',
  Eddv = 'EDDV',
  Lepa = 'LEPA',
  Loww = 'LOWW',
}

export enum ISOCountry {
  At = 'AT',
  De = 'DE',
  Es = 'ES',
}

export enum ISORegion {
  At9 = 'AT-9',
  DeBW = 'DE-BW',
  DeBe = 'DE-BE',
  DeBy = 'DE-BY',
  DeHe = 'DE-HE',
  DeHh = 'DE-HH',
  DeNI = 'DE-NI',
  DeNw = 'DE-NW',
  DeSn = 'DE-SN',
  EsPm = 'ES-PM',
}

export enum Keyword {
  Air = 'Air',
  Airport = 'Airport,',
  BER = 'BER,',
  Base = 'Base',
  Edaf = 'EDAF,',
  Flughafen = 'Flughafen',
  Franz = 'Franz',
  Joan = 'Joan',
  Josef = 'Josef',
  KeywordAirport = 'Airport',
  Köln = 'Köln',
  Lesj = 'LESJ',
  Lilienthal = 'Lilienthal',
  München = 'München',
  Nürnberg = 'Nürnberg',
  Otto = 'Otto',
  RheinMain = 'Rhein-Main',
  Sant = 'Sant',
  Schkeuditz = 'Schkeuditz',
  Son = 'Son',
  Strauss = 'Strauss',
  Strauß = 'Strauß',
}

export enum Municipality {
  Berlin = 'Berlin',
  Cologne = 'Cologne',
  Düsseldorf = 'Düsseldorf',
  FrankfurtAmMain = 'Frankfurt am Main',
  Hamburg = 'Hamburg',
  Hannover = 'Hannover',
  Leipzig = 'Leipzig',
  Munich = 'Munich',
  Münster = 'Münster',
  Nuremberg = 'Nuremberg',
  PalmaDeMallorca = 'Palma De Mallorca',
  Stuttgart = 'Stuttgart',
  Vienna = 'Vienna',
}

export enum ScheduledService {
  Yes = 'yes',
}

export enum AirportType {
  LargeAirport = 'large_airport',
}

export enum ConnectionDirection {
  O = 'O',
  R = 'R',
}

export interface CruisesList {
  name: string
  duration: number
  startHabour: string
  endHabour: string
  regionIDs: RegionID[]
  routeMap: string
  portImages: string[]
  cruises: CruiseElement[]
}

export interface CruiseElement {
  cruiseID: string
  start: string
  end: string
  ship: ShipEnum
  airports: AirportElement[]
  prices: Prices
  datesDisplay?: string
}

export enum AirportElement {
  Bre = 'BRE',
  Bsl = 'BSL',
  Cgn = 'CGN',
  Drs = 'DRS',
  Dus = 'DUS',
  Erf = 'ERF',
  FMO = 'FMO',
  Fdh = 'FDH',
  Fra = 'FRA',
  Haj = 'HAJ',
  Ham = 'HAM',
  Lej = 'LEJ',
  Muc = 'MUC',
  Nue = 'NUE',
  Pad = 'PAD',
  Rlg = 'RLG',
  Str = 'STR',
  Sxf = 'SXF',
  Txl = 'TXL',
  Vie = 'VIE',
  Zrh = 'ZRH',
}

export interface Prices {
  '200': The200[]
}

export interface The200 {
  amount: number
  priceModel: The200_PriceModel
  flight?: boolean
  surcharges: Surcharge[]
}

export enum The200_PriceModel {
  Ind = 'IND',
  Pauschal = 'PAUSCHAL',
  Vario = 'VARIO',
}

export enum ShipEnum {
  AIDAaura = 'AIDAaura',
  AIDAbella = 'AIDAbella',
  AIDAblu = 'AIDAblu',
  AIDAcara = 'AIDAcara',
  AIDAdiva = 'AIDAdiva',
  AIDAluna = 'AIDAluna',
  AIDAmar = 'AIDAmar',
  AIDAmira = 'AIDAmira',
  AIDAnova = 'AIDAnova',
  AIDAperla = 'AIDAperla',
  AIDAprima = 'AIDAprima',
  AIDAsol = 'AIDAsol',
  AIDAstella = 'AIDAstella',
  AIDAvita = 'AIDAvita',
}

export enum RegionID {
  Vrad = 'VRAD',
  Vraf = 'VRAF',
  Vras = 'VRAS',
  Vrdu = 'VRDU',
  Vrio = 'VRIO',
  Vrka = 'VRKA',
  Vrkm = 'VRKM',
  Vrna = 'VRNA',
  Vrne = 'VRNE',
  Vrom = 'VROM',
  Vros = 'VROS',
  Vrse = 'VRSE',
  Vrsk = 'VRSK',
  Vrsp = 'VRSP',
  Vrwe = 'VRWE',
  Vrwm = 'VRWM',
  Vrwr = 'VRWR',
}

export interface OtherSelectedFlightClass {
  code: string
  name: string
  nameShort: string
  price: number
  direction: string
}

export interface EntryRegulation {
  buttonValid: boolean
  buttonTouched: boolean
  countryList: any[]
  cruiseLine: string
  documentList: any[]
  documentIDList: any[]
  email: boolean
  emailAddress: null
  emailSended: boolean
  emailValid: null
  insuranceIDList: any[]
  insuranceList: any[]
}

export interface Excursions {
  list: any[]
  current: TrapaniSnowLeopard
  goBackRoute: null
  goBackParams: TrapaniSnowLeopard
}

export interface Ports {
  ports: any[]
  currentPort: TrapaniSnowLeopard
  currentPortCountry: TrapaniSnowLeopard
  currentPortCruises: TrapaniSnowLeopard
  currentPortExcursions: any[]
  currentCruiseId: null
  goBackRoute: null
  goBackParams: TrapaniSnowLeopard
}

export interface Search {
  params: PauschalTeaserOffersParams
  backgroundImages: string[]
  flights: SearchFlights
  searchResults: SearchResult[]
  ssrResults: any[]
  paramsTouched: boolean
  searchButtonTouched: boolean
  availableRegions: SelectedCountry[]
  availableShips: SelectedCountry[]
  availableAirports: SelectedCountry[]
  availableDurations: AvailableDuration[]
  availableExtraFilters: SelectedCountry[]
}

export interface SearchFlights {
  FRA: { [key: string]: FRAValue }
}

export interface FRAValue {
  A0J1C0?: ChiangMaiGoose
  A1J0C0?: ChiangMaiGoose
  A2J0C0?: ChiangMaiGoose
  A0J1C1?: ChiangMaiGoose
  A1J1C0?: ChiangMaiGoose
  A0J2C0?: ChiangMaiGoose
  A1J0C1?: ChiangMaiGoose
  A2J1C0?: ChiangMaiGoose
  A0J2C1?: ChiangMaiGoose
  A3J0C0?: ChiangMaiGoose
  A1J0C2?: ChiangMaiGoose
  A2J0C1?: ChiangMaiGoose
  A0J3C0?: ChiangMaiGoose
  A1J1C1?: ChiangMaiGoose
  A1J2C0?: ChiangMaiGoose
  A0J1C2?: ChiangMaiGoose
  A2J1C1?: ChiangMaiGoose
  A2J2C0?: ChiangMaiGoose
  A0J1C3?: ChiangMaiGoose
  A2J0C2?: ChiangMaiGoose
  A1J3C0?: ChiangMaiGoose
  A1J0C3?: ChiangMaiGoose
  A3J1C0?: ChiangMaiGoose
  A0J3C1?: ChiangMaiGoose
  A0J4C0?: ChiangMaiGoose
  A1J1C2?: ChiangMaiGoose
  A1J2C1?: ChiangMaiGoose
  A0J2C2?: ChiangMaiGoose
  A4J0C0?: ChiangMaiGoose
  A3J0C1?: ChiangMaiGoose
  A2J3C0?: EsbjergCougar
  A3J0C2?: EsbjergCougar
  A2J0C3?: EsbjergCougar
  A1J4C0?: EsbjergCougar
  A2J1C2?: EsbjergCougar
  A0J4C1?: EsbjergCougar
  A3J1C1?: EsbjergCougar
  A4J1C0?: EsbjergCougar
  A0J5C0?: EsbjergCougar
  A1J1C3?: EsbjergCougar
  A1J2C2?: EsbjergCougar
  A5J0C0?: EsbjergCougar
  A1J0C4?: EsbjergCougar
  A2J2C1?: EsbjergCougar
  A0J3C2?: EsbjergCougar
  A0J1C4?: EsbjergCougar
  A3J2C0?: EsbjergCougar
  A4J0C1?: EsbjergCougar
  A0J2C3?: EsbjergCougar
  A1J3C1?: EsbjergCougar
}

export interface ChiangMaiGoose {
  IND?: number
  VARIO?: number
  PAUSCHAL?: number
}

export interface EsbjergCougar {
  IND: number
  VARIO?: number
}

export interface SearchResult {
  name: string
  duration: number
  startHabour: string
  endHabour: string
  regionIDs: RegionID[]
  routeMap: string
  portImages: string[]
  cruises: CruiseElement[]
  description: string
  images: string[]
}

export interface Ships {
  ships: PersonaeClass
  news: PersonaeClass
  campaigns: PersonaeClass
  cruises: ShipsCruises
}

export interface ShipsCruises {
  lists: TrapaniSnowLeopard
}

export interface Tracking {
  bea: Bea
  planning: TrapaniSnowLeopard
}

export interface Bea {
  agencyId: null
  trackingPixelActivated: boolean
  aidaSource: string
  userType: string
}

export const varioTypeMapping: VarioTypeMapping = {
  ['Suite']: 'JV',
  ['Verandakabine-Deluxe']: 'DV',
  ['Panoramakabine']: 'DV',
  ['Panorama-Balkonkabine']: 'PV',
  ['Verandakabine-Komfort']: 'KV',
  ['Verandakabine']: 'VV',
  ['Balkonkabine']: 'BV',
  ['Meerblickkabine']: 'MV',
  ['Innenkabine']: 'IV',
}